export enum RefereeStep {
  INVITED = 'INVITED',
  REGISTERED = 'REGISTERED',
  DEPOSITED = 'DEPOSITED'
}
